<div class="parallax">

  <div class="gradesHeaderImg container">
    <div class="heroContent english">
      <h1>Materials List</h1>
    </div>
    <div class="heroContent spanish hidden">
      <h1>Materiales para la clase</h1>
    </div>
  </div>
  <section class="backgroundImages" style="top: 0px;">
    <div class="centeredDiv zoom-images">
      <div anchor-target="body" class="heroOverlay"
           data-600-start="background:rgba(0, 0, 0, 0.5)"
           data-start="background:rgba(0, 0, 0, 0)"></div>
      <div anchor-target="body" class="backgroundImage"
           data-600-start="transform: scale(1.3)"
           data-start="transform: scale(1)" id="materialsHeader">
          
           <span class="english" role="img" aria-label="Material page is where you may download and copy any of the materials for use in your classroom at no charge"></span>
           <span class="spanish hidden" role="img" aria-label="La página de materiales es donde podrá descargar y copiar sin costo el material para su uso en su clase."></span>
      </div>
    </div>
  </section>



  <div class="container main" id="skrollr-body">
    <div class="row" style="width: 100%;">
      <div class="col-md-8 gradeContent about">

        <div class="infoBlock english">
          <p>You may download and copy any of these materials for use
            in your classroom. <strong>There is no
              charge to use these materials</strong>. Some items
            can be personalized: On the job offer form,
            for example, you can fill in the blanks onscreen and
            print an individual offer for each of your
            students.</p>
          <p>You may need to turn off your pop-up blocker to open
            these forms.</p>
          <p>Adobe Reader is required to view certain documents
            online. If you don't have it, you can download it
            free of charge from Adobe's website. On the <a
              href="http://www.adobe.com" target="_blank" aria-label="Adobe homepage. Opens in a new tab" class="c11n-link c11n-link--primary c11n-link--reinforced"><span class="c11n-link__content">Adobe
              homepage</span></a>, you will find a section labeled
            "Download" that contains a link for Adobe Reader
          </p>
          <p>If your school lacks the resources to print or copy
            materials from this site, you may order copies
            from us. Vanguard will mail you individual items you
            choose or the complete kit for the grade you
            teach.  
            
            <span class="simulator" id="order">
              <c11n-button 
                class="globalButton page-button"
                labelText="Order materials"
                [size]="'large'"
                [routerLink]="'/order-materials' | langLink"
                buttonType="button">
              </c11n-button>
            </span><br/></p>
            
        </div>
        <div class="infoBlock spanish hidden">
          <p>Puede descargar y copiar cualquiera de estos materiales
            para usar en su clase. <strong>No hay ningún
              costo por usar estos materiales</strong>. Algunos
            elementos se pueden personalizar: en el
            formulario de oferta de trabajo, por ejemplo, puede
            completar los espacios en blanco e imprimir una
            oferta individual para cada uno de sus alumnos.</p>
          <p>Es posible que deba desactivar su bloqueador de elementos
            emergentes para abrir estos formularios.
          </p>
          <p>Se requiere Adobe Reader para ver ciertos documentos en
            línea. Si no lo tiene, puede descargarlo sin
            costo desde el sitio web de Adobe. <a
              href="http://www.adobe.com" target="_blank" aria-label="Página de inicio de Adobe. Se abre en una nueva pestaña" class="c11n-link c11n-link--primary c11n-link--reinforced"><span class="c11n-link__content">En la
              página de
              inicio de Adobe</span></a>, encontrará una sección titulada
            "Descargar" que contiene un enlace para
            Adobe Reader.</p>
          <p>Si su escuela no cuenta con los recursos para imprimir o
            copiar materiales de este sitio de la web,
            puede solicitar copias a nosotros. Vanguard le enviará
            por correo los artículos individuales que
            elija o el kit completo para el grado que usted enseñe.
            
            <span
              class="simulator" id="order">
                  <c11n-button 
                  class="globalButton page-button"
                  labelText="Pedir materiales"
                  [size]="'large'"
                  [routerLink]="'/order-materials' | langLink"
                  buttonType="button">
                </c11n-button>                                
              </span><br/></p>
        </div> <!-- spanish end -->
      </div>
      <div class="col-md-4 gradeContent about">
        <!--a href="assets/printables/en/Misc/MyCE_Best_Practices.pdf">
                    <h4>Hi There</h4>
                </a-->
      </div> <!-- column end -->
    </div> <!-- row end -->

    <div class="row" style="width: 100%;">
      <div class="col-md-4 sidebar materials
                materialsContent">
        <div class="sidebarNav k1">
        <button class="side-nav-btn accordionCloseFull english" data-toggle="collapse" href="#collapse1" aria-expanded="true">
          <h4 class="about">Elementary School</h4>
        </button>
        <button class="side-nav-btn accordionCloseFull spanish hidden" data-toggle="collapse" href="#collapse1" aria-expanded="true">
          <h4 class="about">Escuela Primaria</h4>
        </button>
          <ul class="panel-collapse collapse in accordion"
              id="collapse1">
            <li>
              <button c11n-link class="active sideNav english" href="#materialsk1" (click)="onSidebarNavClick('materialsk1')">Grades K-1</button>
            </li>
            <li>
              <button c11n-link class="sideNav english" href="#materials23" (click)="onSidebarNavClick('materials23')">Grades 2-3</button>
            </li>
            <li>
              <button c11n-link class="sideNav english" href="#materials45" (click)="onSidebarNavClick('materials45')">Grades 4-5</button>
            </li>
            <li>
              <button c11n-link class="active sideNav spanish hidden" href="#materialsk1" (click)="onSidebarNavClick('materialsk1')">Grados K-1</button>
            </li>
            <li>
              <button c11n-link class="sideNav spanish hidden" href="#materials23" (click)="onSidebarNavClick('materials23')">Grados 2-3</button>
            </li>
            <li>
              <button c11n-link class="sideNav spanish hidden" href="#materials45" (click)="onSidebarNavClick('materials45')">Grados 4-5</button>
            </li>
          </ul>
        </div>
        <div class="sidebarNav k1">
        <button class="side-nav-btn accordionOpenFull english" data-toggle="collapse" href="#collapse2" aria-expanded="false">
          <h4 class="about">Middle School</h4>
        </button>
        <button class="side-nav-btn accordionOpenFull spanish hidden" data-toggle="collapse" href="#collapse2" aria-expanded="false">
          <h4 class="about">Secundaria</h4>
        </button>
          <ul class="panel-collapse collapse accordion"
              id="collapse2">
            <li>
              <button c11n-link class="sideNav english" href="#materials6" (click)="onSidebarNavClick('materials6')">Grade 6</button>
            </li>
            <li>
              <button c11n-link class="sideNav english" href="#materials78" (click)="onSidebarNavClick('materials78')">Grades 7-8</button>
            </li>
            <li>
              <button c11n-link class="sideNav spanish hidden" href="#materials6" (click)="onSidebarNavClick('materials6')">Grado 6</button>
            </li>
            <li>
              <button c11n-link class="sideNav spanish hidden" href="#materials78" (click)="onSidebarNavClick('materials78')">Grados 7-8</button>
            </li>
          </ul>
        </div>
        <div class="sidebarNav k1">
          <button class="side-nav-btn accordionOpenFull english" data-toggle="collapse" href="#collapse3" aria-expanded="false">
            <h4 class="about">High School</h4>
          </button>
          <button class="side-nav-btn accordionOpenFull spanish hidden" data-toggle="collapse" href="#collapse3" aria-expanded="false">
            <h4 class="about">Bachillerato</h4>
          </button>
          <ul class="panel-collapse collapse accordion"
              id="collapse3">
            <li>
              <button c11n-link class="sideNav english" href="#materials910" (click)="onSidebarNavClick('materials910')">Grades 9-10</button>
            </li>
            <li>
              <button c11n-link class="sideNav english" href="#materials1112" (click)="onSidebarNavClick('materials1112')">Grades 11-12</button>
            </li>
            <li>
              <button c11n-link class="sideNav spanish hidden" href="#materials910" (click)="onSidebarNavClick('materials910')">Grados 9-10</button>
            </li>
            <li>
              <button c11n-link class="sideNav spanish hidden" href="#materials1112" (click)="onSidebarNavClick('materials1112')">Grados 11-12</button>
            </li>
          </ul>
        </div>

        <div class="sidebarNav"><button c11n-link class="sideNav"
                                      href="#videoMaterials" (click)="onSidebarNavClick('videoMaterials')">
                        <h4 class="about english">Introduction videos</h4>
                        <h4 class="about spanish hidden">Videos de Introducción</h4>
        </button></div>
      </div>

      <div class="col-md-8 gradeContent
                materialsContent" id="materialsTables">

        <!-- GRADES K-1  -->
        <div class="gradesInnerContent" id="materialsk1" #materialsk1 tabindex="-1">
          <h3 class="about k1 english">Grades K–1</h3>
          <div class="infoBlock english">
            <h3>Introductory items</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-k-1">Program Guide K-1 <sub>(website's program section)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/K-1/Program_Guide_K-1.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-k-1"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-k-1">Letter to administrator</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/K-1/Letter_Administrator_K-1.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-k-1"></a></div>
              </div>
            </div>

            <h3>Items</h3>
            <div>
              <div class="materials-row">
                <p id="bills-1-k-1">$1 Bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/K-1/Bills_1_K-1.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-1-k-1"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-k-1">Job Posters</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/K-1/Job_Posters_K-1.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-k-1"></a></div>
              </div>
              <div class="materials-row">
                <p id="saver-cert-k-1">Saver certificate</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/K-1/Saver_Cert_K-1.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  araia-labelledby="saver-cert-k-1"></a></div>
              </div>
            </div>

            <h3>Supplies to have on hand</h3>
            <div>
              <div class="materials-row">
                <p>Envelopes</p>
              </div>
              <div class="materials-row">
                <p>Portfolio folders</p>
              </div>
              <div class="materials-row">
                <p>Cash box or envelope</p>
              </div>
              <div class="materials-row">
                <p>Items for store</p>
              </div>
            </div>
          </div>
          <h3 class="about k1 spanish hidden">Grados K–1</h3>
          <div class="infoBlock spanish hidden">
            <h3>Elementos introductorios</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-k-1-es">Guía del programa K—1 <sub>(sección del programa de la página web)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/K-1/Program_Guide_K-1_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-k-1-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-k-1-es">Carta para los administradores</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/K-1/Letter_Administrator_K-1_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-k-1-es"></a></div>
              </div>
            </div>

            <h3>Items</h3>
            <div>
              <div class="materials-row">
                <p id="bills-1-k-1-es">Billetes de $1</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/K-1/Bills_1_K-1_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-1-k-1-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-k-1-es">Afiches de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/K-1/Job_Posters_K-1_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-k-1-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="saver-cert-k-1-es">Certificado de ahorro</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/K-1/Saver_Cert_K-1_ES.pdf')">
                  <img src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-cert-k-1-e"></a></div>
              </div>
            </div>

            <h3>Suministros para tener al alcance</h3>
            <div>
              <div class="materials-row">
                <p>Sobres</p>
              </div>
              <div class="materials-row">
                <p>Carpetas de portafolios</p>
              </div>
              <div class="materials-row">
                <p>Caja de dinero</p>
              </div>
              <div class="materials-row">
                <p>Artículos para la tienda</p>
              </div>
            </div>
          </div>
        </div>

        <!-- GRADES 2-3  -->
        <div class="gradesInnerContent hidden" id="materials23" #materials23 tabindex="-1">
          <h3 class="about k1 english">Grades 2–3</h3>
          <div class="infoBlock english">
            <h3>Introductory items</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-2-3">Program Guide 2—3 <sub>(website's program section)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Program_Guide_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parents-2-3">Letter to parents</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Letter_Parents_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parents-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-2-3">Letter to administrator</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Letter_Administrator_2-3.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-2-3"></a></div>
              </div>
            </div>

            <h3>Employment</h3>
            <div>
              <div class="materials-row">
                <p id="payday-video-2-3">Payday video</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S01.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="payday-video-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-application-2-3">Job application</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Job_Application_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-application-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-2-3">Job posters</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Job_Posters_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="paycheck-2-3">Paycheck</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Paycheck_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="paycheck-2-3"></a></div>
              </div>
            </div>

            <h3>Banking</h3>
            <div>
              <div class="materials-row">
                <p id="bank-log-2-3">Bank log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Bank_Log_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-2-3"></a></div>
              </div>
            </div>

            <h3>Fines &amp; tickets</h3>
            <div>
              <div class="materials-row">
                <p id="fine-ticket-2-3">Fine tickets</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Fine_Ticket_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="fine-ticket-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="offense-log-2-3">Offense log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Offense_Log_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="offense-log-2-3"></a></div>
              </div>
            </div>

            <h3>Cash</h3>
            <div>
              <div class="materials-row">
                <p id="bills-5-2-3">$5 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Bills_5_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-5-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-10-2-3">$10 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Bills_10_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-10-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-20-2-3">$20 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Bills_20_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-20-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-50-2-3">$50 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Bills_50_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-50-2-3"></a></div>
              </div>
            </div>

            <h3>Rent &amp; deeds</h3>
            <div>
              <div class="materials-row">
                <p id="unpaid-rent-notice-2-3">Unpaid rent notice</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Unpaid_Rent_Notice_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-rent-notice-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="desk-deed-2-3">Deed to desk</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Desk_Deed_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="desk-deed-2-3"></a></div>
              </div>
            </div>

            <h3>Auctions</h3>
            <div>
              <div class="materials-row">
                <p id="auction-video-2-3">Auction video</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S04.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="auction-video-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-record-2-3">Auction record form</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Auction_Record_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-paddle-2-3">Auction paddle</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Auction_Paddle_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-paddle-2-3"></a></div>
              </div>
            </div>
            
            <h3>Year-end certificates</h3>
            <div>
              <div class="materials-row">
                <p id="saver-certs-2-3">Saver certificates (Includes Saver, Super, and Ultimate awards)</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Saver_Certs_2-3.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-certs-2-3"></a></div>
              </div>
            </div>

            <h3>Posters &amp; handouts</h3>
            <div>
              <div class="materials-row">
                <p id="bonus-list-2-3">Bonus list</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Bonus_List_2-3.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="bonus-list-2-3"></a></div>
              </div>
              <div class="materials-row">
                <p id="fine-list-2-3">Fine list</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/2-3/Fine_List_2-3.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="fine-list-2-3"></a></div>
              </div>
            </div>

            <h3>Supplies to have on hand</h3>
            <div>
              <div class="materials-row"> <p>Envelopes</p></div>
              <div class="materials-row"> <p>Portfolio folders</p></div>
              <div class="materials-row"> <p>Cash drawer or box</p></div>
              <div class="materials-row"> <p>Popsicle sticks for auction paddles</p></div>
              <div class="materials-row"> <p>Sticky notes</p></div>
              <div class="materials-row"> <p>Clipboard</p></div>
              <div class="materials-row"> <p>Auction items</p></div>
            </div>
          </div>

          <h3 class="about k1 spanish hidden">Grados 2–3</h3>
          <div class="infoBlock spanish hidden">
            <h3>Elementos introductorios</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-2-3-es">Guía del programa 2—3 <sub>(sección del programa de la página web)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Program_Guide_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parents-2-3-es">Carta para los padres</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Letter_Parents_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parents-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-2-3-es">Carta para los administradores</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Letter_Administrator_2-3_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-2-3-es"></a></div>
              </div>
            </div>

            <h3>Empleo</h3>
            <div>
              <div class="materials-row">
                <p id="payday-video-2-3-es">Video sobre el día de pago</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S01.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="payday-video-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-application-2-3-es">Aplicación de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Job_Application_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-application-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-2-3-es">Afiches de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Job_Posters_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="paycheck-2-3-es">Sueldo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Paycheck_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="paycheck-2-3-es"></a></div>
              </div>
            </div>

            <h3>Bancario/a</h3>
            <div>
              <div class="materials-row">
                <p id="bank-log-2-3-es">Registro bancario</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Bank_Log_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-2-3-es"></a></div>
              </div>
            </div>

            <h3>Multas</h3>
            <div>
              <div class="materials-row">
                <p id="fine-ticket-2-3-es">Tiquetes de multa</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Fine_Ticket_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="fine-ticket-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="offense-log-2-3-es">Registro de ofensas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Offense_Log_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="offense-log-2-3-es"></a></div>
              </div>
            </div>

            <h3>Dinero</h3>
            <div>
              <div class="materials-row">
                <p id="bills-5-2-3-es">Billetes de $5</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Bills_5_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-5-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-10-2-3-es">Billetes de $10</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Bills_10_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-10-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-20-2-3-es">Billetes de $20</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Bills_20_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-20-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-50-2-3-es">Billetes de $50</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Bills_50_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-50-2-3-es"></a></div>
              </div>
            </div>

            <h3>Alquiler y título de propiedad</h3>
            <div>
              <div class="materials-row">
                <p id="unpaid-rent-notice-2-3-es">Aviso de renta no pagada</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Unpaid_Rent_Notice_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-rent-notice-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="desk-deed-2-3-es">Título de propiedad del escritorio</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Desk_Deed_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="desk-deed-2-3-es"></a></div>
              </div>
            </div>

            <h3>Subastas</h3>
            <div>
              <div class="materials-row">
                <p id="auction-video-2-3-es">Video sobre subastas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S04.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="auction-video-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-record-2-3-es">Formulario de registro de subasta</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Auction_Record_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-paddle-2-3-es">Paleta de subastas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Auction_Paddle_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-paddle-2-3-es"></a></div>
              </div>
            </div>

            <h3>Certificados de fin de año</h3>
            <div>
              <div class="materials-row">
                <p id="saver-certs-2-3-es">Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Saver_Certs_2-3_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-certs-2-3-es"></a></div>
              </div>
            </div>

            <h3>Afiches y folletos</h3>
            <div>
              <div class="materials-row">
                <p id="bonus-list-2-3-es">Lista de bonificaciones</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Bonus_List_2-3_ES.doc')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="bonus-list-2-3-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="fine-list-2-3-es">Lista de multas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/2-3/Fine_List_2-3_ES.doc')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="fine-list-2-3-es"></a></div>
              </div>
            </div>

            <h3>Suministros para tener al alcance</h3>
            <div>
              <div class="materials-row"> <p>Sobres</p></div>
              <div class="materials-row"> <p>Carpetas de portafolios</p></div>
              <div class="materials-row"> <p>Caja de dinero</p></div>
              <div class="materials-row"> <p>Palos de paleta para las paletas de subasta</p></div>
              <div class="materials-row"> <p>Notas adhesivas</p></div>
              <div class="materials-row"> <p>Portapapeles</p></div>
              <div class="materials-row"> <p>Artículos de subasta</p></div>
            </div>
          </div>
        </div>

        <!-- GRADES 4-5 -->
        <div class="gradesInnerContent hidden" id="materials45" #materials45 tabindex="-1">
          <h3 class="about k1 english">Grades 4–5</h3>
          <div class="infoBlock english">
            <h3>Introductory items</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-4-5">Program Guide 4—5 <sub>(website's program section)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Program_Guide_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parents-4-5">Letter to parents</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Letter_Parents_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parents-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-4-5">Letter to administrator</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Letter_Administrator_4-5.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon" ></a></div>
              </div>
            </div>

            <h3>Employment</h3>
            <div>
              <div class="materials-row">
                <p id="payday-video-4-5">Payday video</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S01.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="payday-video-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-application-4-5">Job application</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Job_Application_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-application-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-4-5">Job offer</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Job_Offer_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-4-5">Job posters</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Job_Posters_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="paycheck-4-5">Paycheck</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Paycheck_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="paycheck-4-5"></a></div>
              </div>
            </div>

            <h3>Banking</h3>
            <div>
              <div class="materials-row">
                <p id="bank-log-4-5">Bank log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Bank_Log_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="bank-slips-4-5">Bank slips</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Bank_Slip_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-slips-4-5"></a></div>
              </div>
            </div>

            <h3>Fines</h3>
            <div>
              <div class="materials-row">
                <p id="fine-tickets-4-5">Fine tickets</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Fine_Ticket_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="fine-tickets-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="offense-log-4-5">Offense log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Offense_Log_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="offense-log-4-5"></a></div>
              </div>
            </div>

            <h3>Cash</h3>
            <div>
              <div class="materials-row">
                <p id="bills-50-4-5">$50 bills <sub>(small bills: see grades 2—3)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Bills_50_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-50-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-100-4-5">$100 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Bills_100_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-100-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-500-4-5">$500 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Bills_500_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-500-4-5"></a></div>
              </div>
            </div>

            <h3>Rent &amp; deeds</h3>
            <div>
              <div class="materials-row">
                <p id="rental-agreement-4-5">Rental agreement</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Rental_Agreement_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="rent-log-4-5">Rent log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Rent_Log_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rent-log-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-rent-4-5">Unpaid rent notice</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Unpaid_Rent_Notice_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-rent-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="desk-deed-4-5">Deed to desk</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Desk_Deed_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="desk-deed-4-5"></a></div>
              </div>
            </div>

            <h3>Auctions</h3>
            <div>
              <div class="materials-row">
                <p id="auction-video-4-5">Auction video</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S04.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="auction-video-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-record-4-5">Auction record form</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Auction_Record_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-paddle-4-5">Auction paddle</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Auction_Paddle_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-paddle-4-5"></a></div>
              </div>
            </div>

            <h3>Year-end certificates</h3>
            <div>
              <div class="materials-row">
                <p id="saver-certs-4-5">Saver certificates (Includes Saver,
                  Super, and Ultimate awards)</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Saver_Certs_4-5.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-certs-4-5"></a></div>
              </div>
            </div>

            <h3>Posters &amp; handouts</h3>
            <div>
              <div class="materials-row">
                <p id="bonus-list-4-5">Bonus list</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Bonus_List_4-5.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="bonus-list-4-5"></a></div>
              </div>
              <div class="materials-row">
                <p id="fine-list-4-5">Fine list</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/4-5/Fine_List_4-5.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="fine-list-4-5"></a></div>
              </div>
            </div>
            
            <h3>Supplies to have on hand</h3>
            <div>
              <div class="materials-row"> <p>Envelopes</p></div>
              <div class="materials-row"> <p>Portfolio folders</p></div>
              <div class="materials-row"> <p>Cash drawer or box</p></div>
              <div class="materials-row"> <p>Popsicle sticks for auction paddles</p></div>
              <div class="materials-row"> <p>Sticky notes</p></div>
              <div class="materials-row"> <p>Clipboard</p></div>
              <div class="materials-row"> <p>Auction items</p></div>
            </div>
          </div>

          <h3 class="about k1 spanish hidden">Grados 4–5</h3>
          <div class="infoBlock spanish hidden">
            <h3>Elementos introductorios</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-4-5-es">Guía del programa 4-5 <sub>(sección del
                  programa de la página web)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Program_Guide_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parents-4-5-es">Carta para los padres</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Letter_Parents_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parents-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-4-5-es">Carta para los administradores</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Letter_Administrator_4-5_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-4-5-es"></a></div>
              </div>
            </div>

            <h3>Empleo</h3>
            <div>
              <div class="materials-row">
                <p id="payday-video-4-5-es">Video sobre el día de pago</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S01.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="payday-video-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-application-4-5-es">Aplicación de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Job_Application_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-application-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-4-5-es">Oferta de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Job_Offer_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-4-5-es">Afiches de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Job_Posters_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="paycheck-4-5-es">Sueldo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Paycheck_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="paycheck-4-5-es"></a></div>
              </div>
            </div>

            <h3>Bancario/a</h3>
            <div>
              <div class="materials-row">
                <p id="bank-log-4-5-es">Registro bancario</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Bank_Log_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bank-slip-4-5-es">Recibos bancarios</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Bank_Slip_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-slip-4-5-es"></a></div>
              </div>
            </div>

            <h3>Multas</h3>
            <div>
              <div class="materials-row">
                <p id="fine-ticket-4-5-es">Tiquetes de multa</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Fine_Ticket_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="fine-ticket-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="offense-log-4-5-es">Registro de ofensas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Offense_Log_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="offense-log-4-5-es"></a></div>
              </div>
            </div>

            <h3>Dinero</h3>
            <div>
              <div class="materials-row">
                <p id="bills-50-4-5-es">Billetes de $50 <sub>(facturas pequeñas:
                  refiera los grados 2-3)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Bills_50_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-50-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-100-4-5-es">Billetes de $100</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Bills_100_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-100-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-500-4-5-es">Billetes de $500</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Bills_500_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-500-4-5-es"></a></div>
              </div>
            </div>

            <h3>Alquiler y título de propiedad</h3>
            <div>
              <div class="materials-row">
                <p id="rental-agreement-4-5-es">Contrato de alquiler</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Rental_Agreement_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="rent-log-4-5-es">Registro de alquiler</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Rent_Log_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rent-log-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-rent-notice-4-5-es">Aviso de renta no pagada</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Unpaid_Rent_Notice_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-rent-notice-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="desk-deed-4-5-es">Título de propiedad del escritorio</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Desk_Deed_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="desk-deed-4-5-es"></a></div>
              </div>
            </div>

            <h3>Subastas</h3>
            <div>
              <div class="materials-row">
                <p id="auction-video-4-5-es">Video sobre subastas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S04.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="auction-video-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-record-4-5-es">Formulario de registro de subasta</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Auction_Record_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-paddle-4-5-es">Paleta de subastas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Auction_Paddle_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-paddle-4-5-es"></a></div>
              </div>
            </div>

            <h3>Certificados de fin de año </h3>
            <div>
              <div class="materials-row">
                <p id="saver-certs-4-5-es">Certificado de ahorro (Incluye los
                  premios Saver, Super y Ultimate)</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Saver_Certs_4-5_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-certs-4-5-es"></a></div>
              </div>
            </div>

            <h3>Afiches y folletos</h3>
            <div>
              <div class="materials-row">
                <p id="bonus-list-4-5-es">Lista de bonificaciones</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Bonus_List_4-5_ES.doc')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="bonus-list-4-5-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="fine-list-4-5-es">Lista de multas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/4-5/Fine_List_4-5_ES.doc')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="fine-list-4-5-es"></a></div>
              </div>
            </div>

            <h3>Suministros para tener al alcance</h3>
            <div>
              <div class="materials-row"> <p>Sobres</p></div>
              <div class="materials-row"> <p>Carpetas de portafolios</p></div>
              <div class="materials-row"> <p>Caja de dinero</p></div>
              <div class="materials-row"> <p>Palos de paleta para las paletas de subasta</p></div>
              <div class="materials-row"> <p>Notas adhesivas</p></div>
              <div class="materials-row"> <p>Portapapeles</p></div>
              <div class="materials-row"> <p>Artículos de subasta</p></div>
            </div>
          </div>
        </div>

        <!-- GRADES 6 -->
        <div class="gradesInnerContent hidden" id="materials6" #materials6 tabindex="-1">
          <h3 class="about english">Grade 6</h3>
          <div class="infoBlock english">
            <h3>Introductory items</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-6">Program Guide 6 <sub>(website's program section)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Program_Guide_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parents-6">Letter to parents</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Letter_Parents_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parents-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-6">Letter to administrator</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Letter_Administrator_6.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-6"></a></div>
              </div>
            </div>

            <h3>Employment</h3>
            <div>
              <div class="materials-row">
                <p id="payday-video-6">Payday video</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S01.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="payday-video-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-application-6">Job application</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Job_Application_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-application-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-6">Job offer</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Job_Offer_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-6">Job posters</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Job_Posters_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="paycheck-6">Paychecks</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Paycheck_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="paycheck-6"></a></div>
              </div>
            </div>

            <h3>Banking</h3>
            <div>
              <div class="materials-row">
                <p id="bank-log-6">Bank log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Bank_Log_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="bank-slip-6">Bank slips</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Bank_Slip_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-slip-6"></a></div>
              </div>
            </div>

            <h3>Fines</h3>
            <div>
              <div class="materials-row">
                <p id="fine-ticket-6">Fine tickets</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Fine_Ticket_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="fine-ticket-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="offense-log-6">Offense log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Offense_Log_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="offense-log-6"></a></div>
              </div>
            </div>

            <h3>Cash</h3>
            <div>
              <div class="materials-row">
                <p id="bills-50-6">$50 bills <sub>(small bills: see grades
                  2—3)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Bills_50_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-50-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-100-6">$100 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Bills_100_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-100-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-500-6">$500 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Bills_500_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-500-6"></a></div>
              </div>
            </div>

            <h3>Rent &amp; deeds</h3>
            <div>
              <div class="materials-row">
                <p id="rental-agreement-6">Rental agreement</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Rental_Agreement_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="rent-log-6">Rent log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Rent_Log_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rent-log-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-rent-notice-6">Unpaid rent notice</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Unpaid_Rent_Notice_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-rent-notice-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="desk-deed-6">Deed to desk</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Desk_Deed_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="desk-deed-6"></a></div>
              </div>
            </div>

            <h3>Auctions</h3>
            <div>
              <div class="materials-row">
                <p id="auction-video-6">Auction video</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S04.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="auction-video-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-record-6">Auction record form</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Auction_Record_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-paddle-6">Auction paddle</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Auction_Paddle_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-paddle-6"></a></div>
              </div>
            </div>

            <h3>Year-end certificates</h3>
            <div>
              <div class="materials-row">
                <p id="saver-certs-6">Saver certificates (Includes Saver,
                  Super, and Ultimate awards)</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Saver_Certs_6.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-certs-6"></a></div>
              </div>
            </div>

            <h3>Posters &amp; handouts</h3>
            <div>
              <div class="materials-row">
                <p id="bonus-list-6">Bonus list</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Bonus_List_6.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="bonus-list-6"></a></div>
              </div>
              <div class="materials-row">
                <p id="fine-list-6">Fine list</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/6/Fine_List_6.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="fine-list-6"></a></div>
              </div>
            </div>

            <h3>Supplies to have on hand</h3>
            <div>
              <div class="materials-row"> <p>Envelopes</p></div>
              <div class="materials-row"> <p>Portfolio folders</p></div>
              <div class="materials-row"> <p>Cash drawer or box</p></div>
              <div class="materials-row"> <p>Popsicle sticks for auction paddles</p></div>
              <div class="materials-row"> <p>Sticky notes</p></div>
              <div class="materials-row"> <p>Clipboard</p></div>
              <div class="materials-row"> <p>Auction items</p></div>
            </div>
          </div>

          <h3 class="about spanish hidden">Grado 6</h3>
          <div class="infoBlock spanish hidden">
            <h3>Elementos introductorios</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-6-es">Guía del programa 6 <sub>(sección del
                  programa de la página web)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Program_Guide_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parents-6-es">Carta para los padres</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Letter_Parents_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parents-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-6-es">Carta para los administradores</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Letter_Administrator_6_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-6-es"></a></div>
              </div>
            </div>

            <h3>Empleo</h3>
            <div>
              <div class="materials-row">
                <p id="payday-video-6-es">Video sobre el día de pago</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S01.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="payday-video-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-application-6-es">Aplicación de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Job_Application_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-application-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-6-es">Oferta de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Job_Offer_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-6-es">Afiches de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Job_Posters_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="paycheck-6-es">Sueldo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Paycheck_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="paycheck-6-es"></a></div>
              </div>
            </div>

            <h3>Bancario/a</h3>
            <div>
              <div class="materials-row">
                <p id="bank-log-6-es">Registro bancario</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Bank_Log_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bank-slip-6-es">Recibos bancarios</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Bank_Slip_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-slip-6-es"></a></div>
              </div>
            </div>

            <h3>Multas</h3>
            <div>
              <div class="materials-row">
                <p id="fine-ticket-6-es">Tiquetes de multa</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Fine_Ticket_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="fine-ticket-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="offense-log-6-es">Registro de ofensas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Offense_Log_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="offense-log-6-es"></a></div>
              </div>
            </div>

            <h3>Dinero</h3>
            <div>
              <div class="materials-row">
                <p id="bills-50-6-es">Billetes de $50 <sub>(facturas pequeñas: refiera los grados 2-3)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Bills_50_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-50-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-100-6-es">Billetes de $100</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Bills_100_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-100-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-500-6-es">Billetes de $500</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Bills_500_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-500-6-es"></a></div>
              </div>
            </div>

            <h3>Alquiler y título de propiedad</h3>
            <div>
              <div class="materials-row">
                <p id="bills-50-6-es">Contrato de alquiler</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Rental_Agreement_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon" ></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-100-6-es">Registro de alquiler</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Rent_Log_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon" ></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-500-6-es">Aviso de renta no pagada</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Unpaid_Rent_Notice_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon" ></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-500-6-es">Título de propiedad del escritorio/p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Desk_Deed_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon" ></a></div>
              </div>
            </div>

            <h3>Subastas</h3>
            <div>
              <div class="materials-row">
                <p id="auction-video-6-es">Video sobre subastas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S04.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="auction-video-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-record-6-es">Formulario de registro de subasta</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Auction_Record_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-paddle-6-es">Paleta de subastas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Auction_Paddle_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-paddle-6-es"></a></div>
              </div>
            </div>

            <h3>Certificados de fin de año</h3>
            <div>
              <div class="materials-row">
                <p id="saver-certs-6-es">Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Saver_Certs_6_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-certs-6-es"></a></div>
              </div>
            </div>

            <h3>Afiches y folletos</h3>
            <div>
              <div class="materials-row">
                <p id="bonus-list-6-es">Lista de bonificaciones</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Bonus_List_6_ES.doc')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="bonus-list-6-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="fine-list-6-es">Lista de multas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/6/Fine_List_6_ES.doc')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="fine-list-6-es"></a></div>
              </div>
            </div>

            <h3>Suministros para tener al alcance</h3>
            <div>
              <div class="materials-row"> <p>Sobres</p></div>
              <div class="materials-row"> <p>Carpetas de portafolios</p></div>
              <div class="materials-row"> <p>Caja de dinero</p></div>
              <div class="materials-row"> <p>Palos de paleta para las paletas de subasta</p></div>
              <div class="materials-row"> <p>Notas adhesivas</p></div>
              <div class="materials-row"> <p>Portapapeles</p></div>
              <div class="materials-row"> <p>Artículos de subasta</p></div>
            </div>
          </div>
        </div>

        <!-- GRADES 7-8 -->
        <div class="gradesInnerContent hidden" id="materials78" #materials78 tabindex="-1">
          <h3 class="about english">Grades 7–8</h3>
          <div class="infoBlock english">
            <h3>Introductory items</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-7-8">Program Guide 7—8 <sub>(website's program section)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Program_Guide_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parents-7-8">Letter to parents</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Letter_Parents_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parents-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-7-8">Letter to administrator</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Letter_Administrator_7-8.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-donation-7-8">Donation request letter</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Letter_Donation_Request_7-8.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-donation-7-8"></a></div>
              </div>
            </div>

            <h3>Employment</h3>
            <div>
              <div class="materials-row">
                <p id="payday-video-7-8">Payday video</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S01.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="payday-video-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-application-7-8">Job application</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Job_Application_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-application-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-7-8">Job offer</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Job_Offer_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-7-8">Job posters</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Job_Posters_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="paycheck-7-8">Paychecks</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Paycheck_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="paycheck-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="business-license-7-8">Business license</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Business_License_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="business-license-7-8"></a></div>
              </div>
            </div>

            <h3>Banking</h3>
            <div>
              <div class="materials-row">
                <p id="bank-slip-7-8">Bank slips</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Bank_Slip_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-slip-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="bank-log-7-8">Classroom bank log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Bank_Log_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-7-8"></a></div>
              </div>
            </div>

            <h3>Fines</h3>
            <div>
              <div class="materials-row">
                <p id="fine-ticket-7-8">Fine tickets</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Fine_Ticket_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="fine-ticket-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="offense-log-7-8">Offense log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Offense_Log_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="offense-log-7-8"></a></div>
              </div>
            </div>

            <h3>Cash</h3>
            <div>
              <div class="materials-row">
                <p id="bills-50-7-8">$50 bills <sub>(small bills: see grades 2—3)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Bills_50_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-50-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-100-7-8">$100 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Bills_100_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-100-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-500-7-8">$500 bills</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Bills_500_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-500-7-8"></a></div>
              </div>
            </div>

            <h3>Rent &amp; deeds</h3>
            <div>
              <div class="materials-row">
                <p id="rental-agreement-7-8">Rental agreement</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Rental_Agreement_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="rent-log-7-8">Rent log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Rent_Log_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rent-log-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-rent-notice-7-8">Unpaid rent notice</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Unpaid_Rent_Notice_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-rent-notice-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="desk-deed-7-8">Deed to desk</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Desk_Deed_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="desk-deed-7-8"></a></div>
              </div>
            </div>

            <h3>Bills &amp; taxes</h3>
            <div>
              <div class="materials-row">
                <p id="bill-pay-log-7-8">Classroom bill pay log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Bill_Pay_Log_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bill-pay-log-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="energy-log-7-8">Classroom energy log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Energy_Log_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="energy-log-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="tax-record-7-8">Tax record form</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Tax_Record_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="tax-record-7-8"></a></div>
              </div>
            </div>

            <h3>Auctions</h3>
            <div>
              <div class="materials-row">
                <p id="auction-video-7-8">Auction video</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S04.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="auction-video-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-record-7-8">Auction record form</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Auction_Record_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-paddle-7-8">Auction paddle</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Auction_Paddle_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-paddle-7-8"></a></div>
              </div>
            </div>

            <h3>Year-end certificates</h3>
            <div>
              <div class="materials-row">
                <p id="saver-certs-7-8">Saver certificates (Includes Saver,
                  Super, and Ultimate awards)</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Saver_Certs_7-8.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-certs-7-8"></a></div>
              </div>
            </div>

            <h3>Posters &amp; handouts</h3>
            <div>
              <div class="materials-row">
                <p id="bonus-list-7-8">Bonus list</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Bonus_List_7-8.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="bonus-list-7-8"></a></div>
              </div>
              <div class="materials-row">
                <p id="fine-list-7-8">Fine list</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/7-8/Fine_List_7-8.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="fine-list-7-8"></a></div>
              </div>
            </div>

            <h3>Supplies to have on hand</h3>
            <div>
              <div class="materials-row"> <p>Envelopes</p></div>
              <div class="materials-row"> <p>Portfolio folders</p></div>
              <div class="materials-row"> <p>Cash drawer or box</p></div>
              <div class="materials-row"> <p>Popsicle sticks for auction paddles</p></div>
              <div class="materials-row"> <p>Sticky notes</p></div>
              <div class="materials-row"> <p>Clipboard</p></div>
              <div class="materials-row"> <p>Auction items</p></div>
            </div>
          </div>

          <h3 class="about spanish hidden">Grados 7–8</h3>
          <div class="infoBlock spanish hidden">
            <h3>Elementos introductorios</h3>
            <div>
              <div class="materials-row">
                <p id="program-guide-7-8-es">Guía del programa 7—8 <sub>(sección del programa de la página de web)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Program_Guide_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parents-7-8-es">Carta para los padres</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Letter_Parents_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parents-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-7-8-es">Carta para los administradores</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Letter_Administrator_7-8_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-donation-7-8-es">Carta de solicitud para donaciones</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Letter_Donation_Request_7-8_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-donation-7-8-es"></a></div>
              </div>
            </div>

            <h3>Empleo</h3>
            <div>
              <div class="materials-row">
                <p id="payday-video-7-8-es">Video sobre el día de pago</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S01.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="payday-video-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-application-7-8-es">Aplicación de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Job_Application_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-application-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-7-8-es">Oferta de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Job_Offer_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-posters-7-8-es">Afiches de trabajo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Job_Posters_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-posters-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="paycheck-7-8-es">Sueldo</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Paycheck_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="paycheck-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="business-license-7-8-es">Licencia de negocios</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Business_License_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="business-license-7-8-es"></a></div>
              </div>
            </div>

            <h3>Bancario/a</h3>
            <div>
              <div class="materials-row">
                <p id="bank-slip-7-8-es">Recibos bancarios</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Bank_Slip_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-slip-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bank-log-7-8-es">El registro de banco para la clase</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Bank_Log_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-7-8-es"></a></div>
              </div>
            </div>

            <h3>Multas</h3>
            <div>
              <div class="materials-row">
                <p id="fine-ticket-7-8-es">Tiquetes de multa</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Fine_Ticket_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="fine-ticket-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="offense-log-7-8-es">Registro de ofensas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Offense_Log_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="offense-log-7-8-es"></a></div>
              </div>
            </div>

            <h3>Dinero</h3>
            <div>
              <div class="materials-row">
                <p id="bills-50-7-8-es">Billetes de $50 <sub>(facturas pequeñas: refiera los grados 2-3)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Bills_50_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-50-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-100-7-8-es">Billetes de $100</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Bills_100_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-100-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bills-500-7-8-es">Billetes de $500</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Bills_500_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bills-500-7-8-es"></a></div>
              </div>
            </div>

            <h3>Alquiler y título de propiedad</h3>
            <div>
              <div class="materials-row">
                <p id="rental-agreement-7-8-es">Contrato de alquiler</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Rental_Agreement_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="rent-log-7-8-es">Registro de alquiler</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Rent_Log_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rent-log-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-rent-notice-7-8-es">Aviso de renta no pagada</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Unpaid_Rent_Notice_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-rent-notice-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="desk-deed-7-8-es">Título de propiedad del escritorio</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Desk_Deed_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="desk-deed-7-8-es"></a></div>
              </div>
            </div>

            <h3>Cuentas e impuestos</h3>
            <div>
              <div class="materials-row">
                <p id="bill-pay-log-7-8-es">Registro de cuentas pagadas de la clase</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Bill_Pay_Log_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bill-pay-log-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="energy-log-7-8-es">Registro de energía de la clase</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Energy_Log_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="energy-log-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="tax-record-7-8-es">Documento de registro de impuestos</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Tax_Record_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="tax-record-7-8-es"></a></div>
              </div>
            </div>

            <h3>Subastas</h3>
            <div>
              <div class="materials-row">
                <p id="auction-video-7-8-es">Video sobre subastas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/CE_S04.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="auction-video-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-record-7-8-es">Forma de registro de subasta</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Auction_Record_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auction-paddle-7-8-es">Paleta de subastas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Auction_Paddle_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-paddle-7-8-es"></a></div>
              </div>
            </div>

            <h3>Certificados de fin de año</h3>
            <div>
              <div class="materials-row">
                <p id="saver-certs-7-8-es">Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Saver_Certs_7-8_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="saver-certs-7-8-es"></a></div>
              </div>
            </div>

            <h3>Afiches y folletos</h3>
            <div>
              <div class="materials-row">
                <p id="bonus-list-7-8-es">Lista de bonificaciones</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Bonus_List_7-8_ES.doc')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="bonus-list-7-8-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="fine-list-7-8-es">Lista de multas</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/7-8/Fine_List_7-8_ES.doc')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="fine-list-7-8-es"></a></div>
              </div>
            </div>

            <h3>Suministros para tener al alcance</h3>
            <div>
              <div class="materials-row"> <p>Sobres</p></div>
              <div class="materials-row"> <p>Carpetas de portafolios</p></div>
              <div class="materials-row"> <p>Caja de dinero</p></div>
              <div class="materials-row"> <p>Palos de paleta para las paletas de subasta</p></div>
              <div class="materials-row"> <p>Notas adhesivas</p></div>
              <div class="materials-row"> <p>Portapapeles</p></div>
              <div class="materials-row"> <p>Artículos de subasta</p></div>
            </div>
          </div>
        </div>

        <!-- GRADES 9-10 -->
        <div class="gradesInnerContent hidden" id="materials910" #materials910 tabindex="-1">
          <h3 class="about nineten english">Grades 9–10</h3>
          <div class="infoBlock english">
            <h3>Introductory items</h3>
            <div>

              <div class="materials-row">
                <p id="program-guide-9-10">Program Guide 9—10 <sub>(website's
                  program section)</sub></p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Program_Guide_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parent-9-10">Letter to parents</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Letter_Parents_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parent-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-9-10">Letter to administrator</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Letter_Administrator_9-10.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="syllabus-9-10">Syllabus</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Syllabus_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="syllabus-9-10"></a></div>
              </div>

            </div>

            <h3>Employment</h3>
            <div>

              <div class="materials-row">
                <p id="job application-9-10">Job application</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Job_Application_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job application-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-9-10">Job offer</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Job_Offer_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="business-license-9-10">Business license</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Business_License_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="business-license-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="auditor-checklist-9-10">Auditor checklist</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Auditor_Checklist_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auditor-checklist-9-10"></a></div>
              </div>

            </div>

            <h3>Banking &amp; bills</h3>
            <div>

              <div class="materials-row">
                <p id="bank-log-9-10">Bank log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Bank_Log_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-9-10">Unpaid bill notice</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Unpaid_Bill_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="bill-payment-log-9-10">Bill payment log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Bill_Pay_Log_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bill-payment-log-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="tax-record-form-9-10">Tax record form</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Tax_Record_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="tax-record-form-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="classroom-energy-log-9-10">Classroom energy log</p>
                <div class=icon><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Energy_Log_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="classroom-energy-log-9-10"></a></div>
              </div>

            </div>

            <h3>Bonuses &amp; fines</h3>
            <div>

              <div class="materials-row">
                <p id="bonus-fine-tickets-9-10">Bonus/fine tickets</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Bonus-Fine_Tickets_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bonus-fine-tickets-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="bonus-fine-log-9-10">Bonus/fine log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Bonus-Fine_Log_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bonus-fine-log-9-10"></a></div>
              </div>

            </div>

            <h3>Rent &amp; deeds</h3>
            <div>

              <div class="materials-row">
                <p id="rental-agreement-9-10">Rental agreement</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Rental_Agreement_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="deed-to-desk-9-10">Deed to desk</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Desk_Deed_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="deed-to-desk-9-10"></a></div>
              </div>

            </div>

            <h3>Personal finance</h3>
            <div>

              <div class="materials-row">
                <p id="investment-log-9-10">Investment log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Investment_Log_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="investment-log-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="insurance-log-9-10">Insurance log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Insurance_Log_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="insurance-log-9-10"></a></div>
              </div>

            </div>

            <h3>Auctions</h3>
            <div>

              <div class="materials-row">
                <p id="auction-record-form-9-10">Auction record form</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Auction_Record_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-form-9-10"></a></div>
              </div>
              <div class="materials-row">
                <p id="donation-request-letter-9-10">Donation request letter</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Letter_Donation_Request_9-10.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="donation-request-letter-9-10"></a></div>
              </div>

            </div>

            <h3>Year-end certificates</h3>
            <div>

              <div class="materials-row">
                <p id="certificate-of-achievement-9-10">Certificate of achievement</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/9-10/Achievement_Cert_9-10.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="certificate-of-achievement-9-10"></a></div>
              </div>

            </div>

            <h3>Supplies to have on hand</h3>
            <div>

              <div class="materials-row">
                <p id="portfolio-folders-9-10">Portfolio folders</p>
              </div>
              <div class="materials-row">
                <p id="shoebox-9-10">Shoebox</p>
              </div>
              <div class="materials-row">
                <p id="auction-items-9-10">Auction items</p>
              </div>

            </div>
          </div>

          <h3 class="about nineten spanish hidden">Grados 9–10</h3>
          <div class="infoBlock spanish hidden">
            <h3>Elementos introductorios</h3>
            <div>

              <div class="materials-row">
                <p id="program-guide-9-10-es">Guía del programa 9—10 <sub>(sección del
                  programa de la página de web)</sub></p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Program_Guide_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parent-9-10-es">Carta para los padres</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Letter_Parents_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parent-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-9-10-es">Carta para los administradores</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Letter_Administrator_9-10_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="syllabus-9-10-es">Silaba</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Syllabus_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="syllabus-9-10-es"></a></div>
              </div>

            </div>

            <h3>Empleo</h3>
            <div>

              <div class="materials-row">
                <p id="job application-9-10-es">Aplicación de trabajo</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Job_Application_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job application-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-9-10-es">Oferta de trabajo</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Job_Offer_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="business-license-9-10-es">Licencia de negocios</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Business_License_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="business-license-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auditor-checklist-9-10-es">Lista de verificación del auditor</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Auditor_Checklist_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auditor-checklist-9-10-es"></a></div>
              </div>

            </div>

            <h3>Bancario/a</h3>
            <div>

              <div class="materials-row">
                <p id="bank-log-9-10-es">Recibos bancarios</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Bank_Log_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-9-10-es">Aviso de factura sin pagar</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Unpaid_Bill_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bill-payment-log-9-10-es">Registro de pago de facturas</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Bill_Pay_Log_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bill-payment-log-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="tax-record-form-9-10-es">Formulario de registro de impuestos</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Tax_Record_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="tax-record-form-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="classroom-energy-log-9-10-es">Registro de energía del aula</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Energy_Log_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="classroom-energy-log-9-10-es"></a></div>
              </div>

            </div>

            <h3>Bonificaciones y multas</h3>
            <div>

              <div class="materials-row">
                <p id="bonus-fine-tickets-9-10-es">Boletos de bonificación/multa</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Bonus-Fine_Tickets_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bonus-fine-tickets-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bonus-fine-log-9-10-es">Registro de bonificación/multa</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Bonus-Fine_Log_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bonus-fine-log-9-10-es"></a></div>
              </div>

            </div>

            <h3>Alquiler y título de propiedad</h3>
            <div>

              <div class="materials-row">
                <p id="rental-agreement-9-10-es">Contrato de alquiler</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Rental_Agreement_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="deed-to-desk-9-10-es">Título de propiedad del escritorio</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Desk_Deed_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="deed-to-desk-9-10-es"></a></div>
              </div>

            </div>

            <h3>Finanzas personales</h3>
            <div>

              <div class="materials-row">
                <p id="investment-log-9-10-es">Registro de inversiones</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Investment_Log_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="investment-log-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="insurance-log-9-10-es">Registro de seguros</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Insurance_Log_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="insurance-log-9-10-es"></a></div>
              </div>

            </div>

            <h3>Subastas</h3>
            <div>

              <div class="materials-row">
                <p id="auction-record-form-9-10-es">Forma de registro de subasta</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Auction_Record_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-form-9-10-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="donation-request-letter-9-10-es">Carta de solicitud de donación</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Letter_Donation_Request_9-10_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="donation-request-letter-9-10-es"></a></div>
              </div>

            </div>

            <h3>Certificados de fin de año</h3>
            <div>

              <div class="materials-row">
                <p id="certificate-of-achievement-9-10-es">Certificado de logro</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/9-10/Achievement_Cert_9-10_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="certificate-of-achievement-9-10-es"></a></div>
              </div>

            </div>

            <h3>Suministros para tener al alcance</h3>
            <div>

              <div class="materials-row">
                <p id="portfolio-folders-9-10-es">Carpetas de portafolios</p>
              </div>
              <div class="materials-row">
                <p id="shoebox-9-10-es">Shoebox</p>
              </div>
              <div class="materials-row">
                <p id="auction-items-9-10-es">Artículos de subasta</p>
              </div>

            </div>

          </div>
        </div>

        <!-- GRADES 11-12 -->
        <div class="gradesInnerContent hidden" id="materials1112" #materials1112 tabindex="-1">
          <h3 class="about nineten english">Grades 11–12</h3>
          <div class="infoBlock english">
            <h3>Introductory items</h3>
            <div>

              <div class="materials-row">
                <p id="program-guide-11—12">Program Guide 11—12 <sub>(website's
                  program section)</sub></p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Program_Guide_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-11—12"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parent-11-12">Letter to parents</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Letter_Parents_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parent-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-11-12">Letter to administrator</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Letter_Administrator_11-12.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="syllabus-11-12">Syllabus</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Syllabus_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="syllabus-11-12"></a></div>
              </div>

            </div>

            <h3>Employment</h3>
            <div>

              <div class="materials-row">
                <p id="job application-11-12">Job application</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Job_Application_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job application-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-11-12">Job offer</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Job_Offer_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="business-license-11-12">Business license</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Business_License_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="business-license-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="auditor-checklist-11-12">Auditor checklist</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Auditor_Checklist_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auditor-checklist-11-12"></a></div>
              </div>

            </div>

            <h3>Banking &amp; bills</h3>
            <div>

              <div class="materials-row">
                <p id="bank-log-11-12">Bank log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Bank_Log_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-11-12">Unpaid bill notice</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Unpaid_Bill_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="bill-payment-log-11-12">Bill payment log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Bill_Pay_Log_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bill-payment-log-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="tax-record-form-11-12">Tax record form</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Tax_Record_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="tax-record-form-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="classroom-energy-log-11-12">Classroom energy log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Energy_Log_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="classroom-energy-log-11-12"></a></div>
              </div>

            </div>

            <h3>Bonuses &amp; fines</h3>
            <div>

              <div class="materials-row">
                <p id="bonus-fine-tickets-11-12">Bonus/fine tickets</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Bonus-Fine_Tickets_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bonus-fine-tickets-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="bonus-fine-log-11-12">Bonus/fine log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Bonus-Fine_Log_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bonus-fine-log-11-12"></a></div>
              </div>

            </div>

            <h3>Rent &amp; deeds</h3>
            <div>

              <div class="materials-row">
                <p id="rental-agreement-11-12">Rental agreement</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Rental_Agreement_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="deed-to-desk-11-12">Deed to desk</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Desk_Deed_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="deed-to-desk-11-12"></a></div>
              </div>

            </div>

            <h3>Personal finance</h3>
            <div>

              <div class="materials-row">
                <p id="budget-log-11-12">Budget log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Budget_Log_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="budget-log-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="credit-card-11-12">Credit card research assignment</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Credit_Card_Research_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="credit-card-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="insurance-log-11-12">Insurance log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Insurance_Log_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="insurance-log-11-12"></a></div>
              </div>

            </div>

            <h3>Investing</h3>
            <div>

              <div class="materials-row">
                <p id="investment-log-11-12">Investment log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Investment_Log_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="investment-log-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="investment-sim-student-11-12">Investment simulator student journal</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Investment_Journal_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="investment-sim-student-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="investment-sim-teacher-11-12">Investment simulator teacher's guide</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Investment_Teachers_Guide_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="investment-sim-teacher-11-12"></a></div>
              </div>

            </div>

            <h3>Auctions</h3>
            <div>

              <div class="materials-row">
                <p id="auction-record-form-11-12">Auction record form</p>
                <div class="icon"d><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Auction_Record_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-form-11-12"></a></div>
              </div>
              <div class="materials-row">
                <p id="donation-request-letter-11-12">Donation request letter</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Letter_Donation_Request_11-12.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="donation-request-letter-11-12"></a></div>
              </div>

            </div>

            <h3>Year-end certificates</h3>
            <div>

              <div class="materials-row">
                <p id="certificate-of-achievement-11-12">Certificate of achievement</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/en/11-12/Achievement_Cert_11-12.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="certificate-of-achievement-11-12"></a></div>
              </div>

            </div>

            <h3>Supplies to have on hand</h3>
            <div>

              <div class="materials-row">
                <p id="portfolio-folders-11-12">Portfolio folders</p>
              </div>
              <div class="materials-row">
                <p id="shoebox-11-12">Shoebox</p>
              </div>
              <div class="materials-row">
                <p id="auction-items-11-12">Auction items</p>
              </div>

            </div>
          </div>

          <h3 class="about nineten spanish hidden">Grados 11–12</h3>
          <div class="infoBlock spanish hidden">
            <h3>Elementos introductorios</h3>
            <div>

              <div class="materials-row">
                <p id="program-guide-11—12-es">Guía del programa 11—12 <sub>(website's
                  program section)</sub></p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Program_Guide_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="program-guide-11—12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-parent-11-12-es">Carta para los padres</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Letter_Parents_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="letter-parent-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="letter-administrator-11-12-es">Carta para los administradores</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Letter_Administrator_11-12_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="letter-administrator-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="syllabus-11-12-es">Silaba</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Syllabus_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="syllabus-11-12-es"></a></div>
              </div>

            </div>

            <h3>Empleo</h3>
            <div>

              <div class="materials-row">
                <p id="job application-11-12-es">Aplicación de trabajo</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Job_Application_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job application-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="job-offer-11-12-es">Oferta de trabajo</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Job_Offer_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="job-offer-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="business-license-11-12-es">Licencia de negocios</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Business_License_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="business-license-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="auditor-checklist-11-12-es">Lista de verificación del auditor</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Auditor_Checklist_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auditor-checklist-11-12-es"></a></div>
              </div>

            </div>

            <h3>Bancario/a</h3>
            <div>

              <div class="materials-row">
                <p id="bank-log-11-12-es">Recibos bancarios</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Bank_Log_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bank-log-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="unpaid-11-12-es">Aviso de factura sin pagar</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Unpaid_Bill_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="unpaid-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bill-payment-log-11-12-es">Registro de pago de facturas</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Bill_Pay_Log_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bill-payment-log-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="tax-record-form-11-12-es">Formulario de registro de impuestos</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Tax_Record_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="tax-record-form-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="classroom-energy-log-11-12-es">Registro de energía del aula</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Energy_Log_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="classroom-energy-log-11-12-es"></a></div>
              </div>

            </div>

            <h3>Bonificaciones y multas</h3>
            <div>

              <div class="materials-row">
                <p id="bonus-fine-tickets-11-12-es">Boletos de bonificación/multa</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Bonus-Fine_Tickets_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bonus-fine-tickets-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="bonus-fine-log-11-12-es">Registro de bonificación/multa</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Bonus-Fine_Log_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="bonus-fine-log-11-12-es"></a></div>
              </div>

            </div>

            <h3>Alquiler y título de propiedad</h3>
            <div>

              <div class="materials-row">
                <p id="rental-agreement-11-12-es">Contrato de alquiler</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Rental_Agreement_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="rental-agreement-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="deed-to-desk-11-12-es">Título de propiedad del escritorio</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Desk_Deed_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="deed-to-desk-11-12-es"></a></div>
              </div>

            </div>

            <h3>Personal finance</h3>
            <div>

              <div class="materials-row">
                <p id="budget-log-11-12-es">Budget log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Budget_Log_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="budget-log-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="credit-card-11-12-es">Credit card research assignment</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Credit_Card_Research_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="credit-card-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="insurance-log-11-12-es">Insurance log</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Insurance_Log_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="insurance-log-11-12-es"></a></div>
              </div>

            </div>

            <h3>Invertir</h3>
            <div>

              <div class="materials-row">
                <p id="investment-log-11-12-es">Registro de inversiones</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Investment_Log_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="investment-log-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="investment-sim-student-11-12-es">Reporte de estudiante de simulador de
                  inversión
                </p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Investment_Journal_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="investment-sim-student-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="investment-sim-teacher-11-12-es">Guía del profesor del simulador de
                  inversiones
                </p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Investment_Teachers_Guide_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="investment-sim-teacher-11-12-es"></a></div>
              </div>

            </div>

            <h3>Subastas</h3>
            <div>

              <div class="materials-row">
                <p id="auction-record-form-11-12-es">Forma de registro de subasta</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Auction_Record_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="auction-record-form-11-12-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="donation-request-letter-11-12-es">Carta de solicitud de donación</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Letter_Donation_Request_11-12_ES.docx')"><img
                  src="assets/images/doc_link.svg" title="Document" alt="Document Icon"  aria-labelledby="donation-request-letter-11-12-es"></a></div>
              </div>

            </div>

            <h3>Certificados de fin de año</h3>
            <div>

              <div class="materials-row">
                <p id="certificate-of-achievement-11-12-es">Certificado de logro</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/printables/es/11-12/Achievement_Cert_11-12_ES.pdf')"><img
                  src="assets/images/pdf_icon.png" title="PDF" alt="PDF Icon"  aria-labelledby="certificate-of-achievement-11-12-es"></a></div>
              </div>

            </div>

            <h3>Suministros para tener al alcance</h3>
            <div>

              <div class="materials-row">
                <p id="portfolio-folders-11-12">Carpetas de portafolios</p>
              </div>
              <div class="materials-row">
                <p id="shoebox-11-12">Shoebox</p>
              </div>
              <div class="materials-row">
                <p id="auction-items-11-12">Artículos de subasta</p>
              </div>

            </div>
          </div>
        </div>

        <!-- VIDEOS -->
        <div class="gradesInnerContent hidden" id="videoMaterials" #videoMaterials tabindex="-1">
          <h3 class="about english">Videos</h3>
          <div class="infoBlock english">
            <p><i>To save a video to your computer, right-click on
              the "Play" icon and select "Save target
              as...", "Download linked file as...", or "Save
              link as..."</i></p>
            <h3>Download intro videos</h3>
            <div>

              <div class="materials-row">
                <p id="video-intro">Intro</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_MainVideo.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-intro"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-how-it-works">How it works</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_HowItWorks.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-how-it-works"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-bonuses">Bonuses</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_Bonuses.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-bonuses"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-rent-and-fines">Rent and fines</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_RentFines.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-rent-and-fines"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-bills-and-taxes">Bills and taxes</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_BillsTaxes.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-bills-and-taxes"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-auctions">Auctions</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_Auctions.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-auctions"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-insurance">Insurance</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_Insurance.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-insurance"></a></div>
              </div>

            </div>
          </div>
          <h3 class="about spanish hidden">Videos</h3>
          <div class="infoBlock spanish hidden">
            <p><i>Para guardar un video en su computadora, haga clic
              derecho en el ícono "Reproducir" y
              seleccione "Save target as...", "Download linked
              file as...", or "Save link as..."</i></p>
            <h3>Descargar videos de introducción</h3>
            <div>

              <div class="materials-row">
                <p id="video-intro-es">Introducción</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_MainVideo.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-intro-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-how-it-works-es">Como funciona</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_HowItWorks.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-how-it-works-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-bonuses-es">Bonos</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_Bonuses.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-bonuses-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-rent-and-fines-es">Renta y Multas</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_RentFines.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-rent-and-fines-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-bills-and-taxes-es">Facturas e impuestos</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_BillsTaxes.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-bills-and-taxes-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-auctions-es">Subastas</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_Auctions.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-auctions-es"></a></div>
              </div>
              <div class="materials-row">
                <p id="video-insurance-es">Inversiones</p>
                <div class="icon"><a href="javascript:void(0);" (click)="modalService.openMaterialsForm($event, 'assets/video/3064_MCE_Insurance.mp4')"><img
                  src="assets/images/video_icon.svg" title="Video" alt="Video Icon"  aria-labelledby="video-insurance-es"></a></div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="hidden" id="orderForms">
        <div class="col-md-4 sidebar">
          <div class="sidebarNav">
            <ul class="panel-collapse collapse in accordion"
                id="collapse1">
              <li class="active sideNav" href="#complete"
                  id="completeSideNav">Order a complete kit
              </li>
              <li class="sideNav" href="#individual"
                  id="individualSideNav">Order individual items
              </li>
            </ul>
          </div>
        </div>

        <div class="col-md-8 gradeContent">
          <div class="gradesInnerContent" id="complete">
            <h3 class="about k1">Order a complete kit</h3>
            <div class="infoBlock">
              <p>If your school lacks resources to print or copy
                materials from this site, Vanguard will mail
                you a packet that includes the classroom
                currency, bank logs, and other items. Your
                classroom materials are sent by FedEx. Please
                note that FedEx does not deliver to a P.O.
                Box, therefore, you must provide a physical
                address to receive your classroom materials.
                Please allow up to ten days for receipt.<strong>
                  If your school is currently closed, please
                  use a home address as someone needs to be
                  present to sign for the package upon arrival.
                </strong></p>


              <form action="materials" id="kitform"
                    method="post" name="orderkit">

                                <span class="inline">
                                    <select name="gradelevel" style="width:100%;
                                        margin-top:30px;">
                                        <option value="">--Grade level--</option>
                                        <option value="K">
                                            Kindergarten</option>
                                        <option value="1">
                                            1st Grade</option>
                                        <option value="2">
                                            2nd Grade</option>
                                        <option value="3">
                                            3rd Grade</option>
                                        <option value="4">
                                            4th Grade</option>
                                        <option value="5">
                                            5th Grade</option>
                                        <option value="6">
                                            6th Grade</option>
                                        <option value="7">
                                            7th Grade</option>
                                        <option value="8">
                                            8th Grade</option>
                                        <option value="9">
                                            9th Grade</option>
                                        <option value="10">
                                            10th Grade</option>
                                        <option value="11">
                                            11th Grade</option>
                                        <option value="12">
                                            12th Grade</option>
                                    </select>
                                </span>

                <span class="inline">
                                    <input aria-invalid="false" aria-required="true" name="students"
                                           placeholder="Number of
                                        students" size="40"
                                           type="text">
                                </span>

                <span class="inline">
                                    <input aria-invalid="false" aria-required="true" name="firstname"
                                           placeholder="Teacher's
                                        first name" size="40"
                                           type="text">
                                </span>

                <span class="inline">
                                    <input aria-invalid="false" aria-required="true" name="lastname"
                                           placeholder="Teacher's
                                        last name" size="40"
                                           type="text">
                                </span>

                <input aria-invalid="false"
                       aria-required="true"
                       name="email" placeholder="you@youremail.com"
                       size="40" type="email">


                <span class="inline">
                                    <input aria-invalid="false" aria-required="true"
                                           name="school"
                                           placeholder="School name" size="40"
                                           type="text">
                                </span>

                <span class="inline">
                                    <input aria-invalid="false" aria-required="true" name="address"
                                           placeholder="Street
                                        address" size="40"
                                           type="text">
                                </span>

                <span class="inline">
                                    <input aria-invalid="false" aria-required="true"
                                           name="city"
                                           placeholder="City" size="40"
                                           type="text">
                                </span>
                <span class="inline">
                                    <input aria-invalid="false" aria-required="true" name="state"
                                           placeholder="State /
                                        Province / Region" size="40"
                                           type="text">
                                </span>

                <span class="inline">
                                    <input aria-invalid="false" aria-required="true" name="zip"
                                           placeholder="ZIP / Postal
                                        Code" size="40"
                                           type="text">
                                </span>
                <span class="inline">
                                    <input aria-invalid="false" aria-required="true"
                                           name="phone"
                                           placeholder="Phone" size="40"
                                           type="tel">
                                </span>
                <span class="inline">
                                    <div style="width:15%;float:left;">
                                        <input class="available-checkbox" name="acknowledgePickup"
                                               style="width: 40px; height:
                                            40px;"
                                               type="checkbox">
                                    </div>
                                    <strong style="float: left; width: 85%;
                                        margin-top: 10px;">Available to sign for
                                        package
                                        at this address</strong>
                                </span>
                <input class="btn btn-default" id="ordersubmit"
                       name="orderkit" type="submit"
                       value="Order Kit">
              </form>
            </div>
          </div>

          <div class="gradesInnerContent hidden" id="individual">
            <h3 class="about k1">Order individual items</h3>
            <div class="infoBlock">
              <p>If your school lacks resources to print or copy
                materials from this site, Vanguard will mail
                you a packet that includes the classroom
                currency, bank logs, and other items. Your
                classroom materials are sent by FedEx. Please
                note that FedEx does not deliver to a P.O.
                Box, therefore, you must provide a physical
                address to receive your classroom materials.
                Please allow up to ten days for receipt.</p>
              <form action="materials" id="itemform"
                    method="post" name="orderitems">
                <div class="row">
                  <h3>Introductory items</h3>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox" value="guidek-1">
                                        Program Guide K–1</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox" value="guide2-3">Program
                                        Guide 2–3</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox" value="guide4-5">Program
                                        Guide 4–5</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox" value="guide4-5">Program
                                        Guide 6</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox" value="guide4-5">Program
                                        Guide 7–8</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox" value="guide4-5">Program
                                        Guide 9–10</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox" value="guide4-5">Program
                                        Guide 11–12</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox"
                    value="parent-letter">Letter to
                                        parents 2–8</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox"
                    value="parent-letter">Letter to
                                        parents 9–12</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox"
                    value="admin-letter">Letter to
                                        administrator k–6</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox"
                    value="admin-letter">Letter to
                                        administrator 7–8</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox"
                    value="admin-letter">Letter to
                                        administrator 9–12</span>
                  <span class="checkbox"><input
                    name="items[program][]"
                    type="checkbox"
                    value="admin-letter">Donation
                                        request letter 7–12</span>


                  <h3>Cash (# of sheets)</h3>
                  <input maxlength="5" name="items[1bills]"
                         size="5" type="text">$1 bills <sup>(six
                  per sheet, or $6 total)</sup>
                  <input maxlength="5" name="items[5bills]"
                         size="5" type="text">$5 bills <sup>(six
                  per sheet, or $30 total)</sup>
                  <input maxlength="5" name="items[10bills]"
                         size="5" type="text">$10 bills <sup>(six
                  per sheet, or $60 total)</sup>
                  <input maxlength="5" name="items[20bills]"
                         size="5" type="text">$20 bills <sup>(six
                  per sheet, or $120 total)</sup>
                  <input maxlength="5" name="items[50bills]"
                         size="5" type="text">$50 bills <sup>(six
                  per sheet, or $300 total)</sup>
                  <input maxlength="5" name="items[100bills]"
                         size="5" type="text">$100 bills <sup>(six
                  per sheet, or $600 total)</sup>
                  <input maxlength="5" name="items[500bills]"
                         size="5" type="text">$500 bills <sup>(six
                  per sheet, or $3000 total)</sup>

                  <h3>Certificates # of sheets</h3>
                  <input maxlength="3" name="items[deed]"
                         size="3" type="text">Deed to desk 2-8
                  <input maxlength="3" name="items[deed]"
                         size="3" type="text">Deed to desk 9-12
                  <input maxlength="3" name="items[saver2-3]"
                         size="3" type="text">Saver certificate
                  K-1
                  <input maxlength="3" name="items[saver2-3]"
                         size="3" type="text">Saver certificate
                  2-3
                  <input maxlength="3"
                         name="items[supersaver2-3]" size="3" type="text">Super
                  saver certificate 2-3
                  <input maxlength="3"
                         name="items[ultimatesaver2-3]" size="3" type="text">Ultimate
                  saver certificate 2-3
                  <input maxlength="3" name="items[saver4-5]"
                         size="3" type="text">Saver certificate
                  4-8
                  <input maxlength="3"
                         name="items[supersaver4-5]" size="3" type="text">Super
                  saver certificate 4-8
                  <input maxlength="3"
                         name="items[ultimatesaver4-5]" size="3" type="text">Ultimate
                  saver 4-8
                  <input maxlength="3"
                         name="items[ultimatesaver4-5]" size="3" type="text">Certificate
                  of achievement 9-12
                  <input maxlength="3"
                         name="items[ultimatesaver4-5]" size="3" type="text">Auditor
                  checklist 9-12
                </div>

                <div class="row">
                  <h3>Recordkeeping # of sheets</h3>
                  <input maxlength="3"
                         name="items[jobapplication]" size="3" type="text">Job
                  application 2-6
                  <input maxlength="3"
                         name="items[jobapplication]" size="3" type="text">Job
                  application 7-8
                  <input maxlength="3"
                         name="items[jobapplication]" size="3" type="text">Job
                  application 9-12
                  <input maxlength="3" name="items[joboffer]"
                         size="3" type="text">Job offer 4-12
                  <br>
                  <input maxlength="3" name="items[paychecks]"
                         size="3" type="text">Paychecks 2-8
                  <sup>(four per sheet)</sup> <br>
                  <input maxlength="3" name="items[banklog2-3]"
                         size="3" type="text">Bank log 2-3
                  <input maxlength="3" name="items[banklog4-5]"
                         size="3" type="text">Bank log 4-6
                  <input maxlength="3" name="items[banklog4-5]"
                         size="3" type="text">Class bank log
                  7-8
                  <input maxlength="3" name="items[banklog4-5]"
                         size="3" type="text">Class bank log
                  9-12
                  <input maxlength="3" name="items[bankslip]"
                         size="3" type="text">Bank slips 4-8
                  <sup>(four per sheet)</sup> <br>
                  <input maxlength="3"
                         name="items[finetickets2-3]" size="3" type="text">Fine
                  tickets 2-3 <sup>(four per sheet)</sup>
                  <input maxlength="3"
                         name="items[finetickets4-5]" size="3" type="text"> Fine
                  tickets 4-8 <sup>(four per sheet)</sup>
                  <input maxlength="3"
                         name="items[finetickets4-5]" size="3" type="text">Bonus/fine
                  slips 9-12 <sup>(four per sheet)</sup>
                  <input maxlength="3"
                         name="items[rentagreement]" size="3" type="text">Rental
                  agreement 4-8 <sup>(two per sheet)</sup>
                  <input maxlength="3"
                         name="items[rentagreement]" size="3" type="text">
                  Rental agreement 9-12 <sup>(two per sheet)
                </sup>
                  <input maxlength="3" name="items[rentlog]"
                         size="3" type="text">Rent log 4-8
                  <input maxlength="3" name="items[unpaidrent]"
                         size="3" type="text">Unpaid rent
                  notice 2-6 <sup>(four per sheet)</sup>
                  <input maxlength="3" name="items[unpaidrent]"
                         size="3" type="text">Unpaid rent
                  notice 7-8 <sup>(four per sheet)</sup>
                  <input maxlength="3" name="items[unpaidrent]"
                         size="3" type="text"> Unpaid bill
                  notice 9-12 <sup>(four per sheet)</sup>
                  <br>
                  <input maxlength="3"
                         name="items[auctionrecord2-3]" size="3" type="text">Auction
                  record form 2-3
                  <input maxlength="3"
                         name="items[auctionrecord4-5]" size="3" type="text">Auction
                  record form 4-8
                  <input maxlength="3"
                         name="items[auctionrecord4-5]" size="3" type="text">Auction
                  record form 9-12
                  <input maxlength="3"
                         name="items[auctionpaddle]" size="3" type="text">Auction
                  paddle card stock
                  <br>
                  <input maxlength="3" name="items[offenselog]"
                         size="3" type="text">Offense log 2-8
                  <input maxlength="3" name="items[offenselog]"
                         size="3" type="text">Bill payment log
                  7-8
                  <input maxlength="3" name="items[offenselog]"
                         size="3" type="text">Bill payment log
                  9-12
                  <input maxlength="3" name="items[offenselog]"
                         size="3" type="text">Classroom energy
                  log 7-12
                  <input maxlength="3" name="items[offenselog]"
                         size="3" type="text">Business license
                  7-12
                  <input maxlength="3" name="items[offenselog]"
                         size="3" type="text">Tax record and
                  form 7-8
                  <input maxlength="3" name="items[offenselog]"
                         size="3" type="text">Tax record and
                  form 9-12

                </div>

                <div class="rowLong">
                                    <span class="inline">
                                        <input aria-invalid="false" aria-required="true" name="students"
                                               placeholder="Number
                                            of students" size="40"
                                               type="text">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false"
                                               aria-required="true"
                                               name="firstname"
                                               placeholder="Teacher's first name" size="40"
                                               type="text">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false"
                                               aria-required="true"
                                               name="lastname"
                                               placeholder="Teacher's last name" size="40"
                                               type="text">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false"
                                               aria-required="true"
                                               name="email"
                                               placeholder="your@email.com" size="40"
                                               type="email">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false" aria-required="true" name="school"
                                               placeholder="School
                                            name" size="40"
                                               type="text">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false" aria-required="true" name="address"
                                               placeholder="Street
                                            address" size="40"
                                               type="text">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false" aria-required="true"
                                               name="city"
                                               placeholder="City" size="40"
                                               type="text">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false" aria-required="true"
                                               name="state"
                                               placeholder="State /
                                            Province / Region" size="40"
                                               type="text">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false" aria-required="true" name="zip"
                                               placeholder="ZIP /
                                            Postal Code" size="40"
                                               type="text">
                                    </span>

                  <span class="inline">
                                        <input aria-invalid="false" aria-required="true"
                                               name="phone"
                                               placeholder="Phone" size="40"
                                               type="tel">
                                    </span>
                  <span class="inline">
                                        <div style="width:15%;float:left;">
                                            <input class="available-checkbox"
                                                   name="acknowledgePickup"
                                                   style="width: 40px; height:
                                                40px;"
                                                   type="checkbox">
                                        </div>
                                        <strong style="float: left; width: 85%;
                                            margin-top: 10px;">Available to sign
                                            for
                                            package at this address</strong>
                                    </span>
                  <input class="btn
                                        btn-default" id="ordersubmit" name="orderitems" type="submit" value="Order
                                        Items">
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>